export default __webpack_public_path__ + "static/media/gplus.82cf9d40.png";